var map = {
	"./Fliege.png": "77ef",
	"./Jacke.png": "5b0f",
	"./Muschel.png": "ee6b",
	"./Roller.png": "bf6e",
	"./Rollschuhe.png": "d695",
	"./Rucksack.png": "285a",
	"./Stab.png": "32da",
	"./Stoeckelschuhe.png": "45af",
	"./Titel.png": "bad8",
	"./Trolley.png": "b711",
	"./Wanderschuhe.png": "93d8",
	"./Wasserflasche.png": "3643",
	"./jacobus_01.png": "4437",
	"./jacobus_02.png": "5749",
	"./jacobus_03.png": "b944",
	"./jacobus_04.png": "edd5",
	"./jacobus_05.png": "b04a",
	"./jacobus_06.png": "0148",
	"./jacobus_07.png": "8fec",
	"./spielfeld.png": "1c4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";